import tmhRequest from '@/config/tmhRequest'

export default {

    initTargetStoreMarket: function (data) {
        return tmhRequest({
            url: '/market/tmh/storemarket/inittargetstoremarket',
            method: 'post',
            params: data,
        })
    },

    searchMarketingCount: function (data) {
        return tmhRequest({
            url: '/market/tmh/marketing/searchmarketingcount',
            method: 'post',
            params: data,
        })
    },

    searchMarketingByPage: function (data) {
        return tmhRequest({
            url: '/market/tmh/marketing/searchmarketingbypage',
            method: 'post',
            params: data,
        })
    },

    addMarketing: function (data) {
        return tmhRequest({
            url: '/market/tmh/marketing/addmarketing',
            method: 'post',
            data: data,
        })
    },

    multiEditStoreMarket: function (data) {
        return tmhRequest({
            url: '/market/tmh/storemarket/multieditstoremarket',
            method: 'post',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/market/storemarket.js